var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.468 2h19.213c.68 0 1.36.1 2.07.43.85.397 1.302 1.023 1.618 1.485.024.036.048.073.069.11.371.663.563 1.377.563 2.145a4.59 4.59 0 0 1-.575 2.239l-12.138 20.85a1.49 1.49 0 0 1-2.58-.01L2.793 8.445l-.01-.017c-.273-.45-.695-1.144-.768-2.04a4.064 4.064 0 0 1 .532-2.368 4.045 4.045 0 0 1 1.788-1.64C5.14 2.002 5.954 2 6.468 2zm8.043 2.979H6.469c-.528-.001-.731.031-.873.098-.196.09-.36.242-.47.432-.11.19-.16.411-.143.632.01.127.062.272.367.774l.018.032 9.143 15.965V4.98zm2.98-.001V22.99l9.354-16.07c.105-.191.177-.469.177-.752.001-.23-.047-.429-.153-.634a2.368 2.368 0 0 0-.236-.304.437.437 0 0 0-.139-.102c-.22-.102-.446-.151-.81-.151h-8.19z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTon);
export default __webpack_public_path__ + "static/media/TON.09a0257a92d410c7b34ad80cd4e983e2.svg";
export { ForwardRef as ReactComponent };